export const getPreExistingConfig = (destinations): Record<string, string> => {
  const defaultConfig = {
    accountID: '',
    region: '',
    accountIdentifier: '',
  };
  const findDestination = destinations.find((d) => d.provider === 'snowflake');

  const configsStringfy = findDestination?.config;

  if (configsStringfy) {
    const parsedJson = JSON.parse(configsStringfy);

    return Object.keys(defaultConfig).reduce((finalObject, value) => {
      finalObject[value] = parsedJson[value] || '';
      return finalObject;
    }, {});
  }

  return defaultConfig;
};
